import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Modal from './Modal';
import { CloseIcon } from '../components/Icon';
import MessagesConnectionList from './MessagesConnectionList';
import { isMobile } from 'react-device-detect';

export default class MessagesModal extends Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    gutterBottom: PropTypes.string,
  };

  static defaultProps = {
    gutterBottom: '5rem',
  };

  state = {
    selectedConnectionListId: null,
  };

  handleListSelect = selectedConnectionListId => {
    this.setState({ selectedConnectionListId });
  };

  render() {
    const { selectedConnectionListId } = this.state;
    const { gutterBottom } = this.props;

    return (
      <Modal
        modalWrapperClassName="u-py-0 md:u-py-16"
        onClose={this.props.onClose}
        style={{
          margin: isMobile ? 0 : `0 0 ${gutterBottom} 0`,
          borderRadius: isMobile ? 0 : '8px',
        }}>
        <div
          className="u-flex u-font-sans u-text-sm messages-modal u-relative u-rounded-lg u-overflow-hidden"
          style={{ height: isMobile ? 'calc(100vh)' : `calc(90vh - ${gutterBottom})` }}>
          <MessagesConnectionList
            selectedConnectionListId={selectedConnectionListId}
            closeModal={this.props.onClose}
            {...this.props}
          />
          {!isMobile && (
            <CloseIcon
              className="u-absolute"
              width="15"
              height="15"
              style={{ top: '15px', right: '15px', cursor: 'pointer' }}
              onClick={this.props.onClose}
            />
          )}
        </div>
      </Modal>
    );
  }
}
